import React, { useState, useEffect } from 'react';
import { SalesforceAPI } from '../services/api';
import './SalesforceLeads.css';

function SalesforceLeads() {
  const [selectedLead, setSelectedLead] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchLeads = async () => {
      try {
        const leadsData = await SalesforceAPI.getLeads();
        console.log('Leads data received:', leadsData); // Debug log
        if (!Array.isArray(leadsData)) {
          throw new Error('Invalid leads data format received');
        }
        setLeads(leadsData);
        setError(null);
      } catch (err) {
        setError('Failed to fetch leads. Please try again later.');
        console.error('Error fetching leads:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchLeads();
  }, []);

  const filteredLeads = leads?.filter(lead =>
    lead.company?.toLowerCase().includes(searchText.toLowerCase()) ||
    lead.email?.toLowerCase().includes(searchText.toLowerCase()) ||
    `${lead.firstName} ${lead.lastName}`.toLowerCase().includes(searchText.toLowerCase()) ||
    lead.status?.toLowerCase().includes(searchText.toLowerCase())
  ) || [];

  if (loading) {
    return <div className="loading">Loading leads...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="leads-container">
      <div className="leads-list">
        <h2>Leads</h2>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search leads..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="search-input"
          />
          <button 
            className="search-button"
            onClick={() => setSearchText('')}
          >
            Clear
          </button>
        </div>
        <div className="leads">
          {filteredLeads.map(lead => (
            <div
              key={lead.id}
              className={`lead-item ${selectedLead?.id === lead.id ? 'selected' : ''}`}
              onClick={() => setSelectedLead(lead)}
            >
              <div className="lead-header">
                <span className="lead-name">{`${lead.firstName} ${lead.lastName}`}</span>
                <span className={`lead-status ${lead.status.toLowerCase()}`}>
                  {lead.status}
                </span>
              </div>
              <div className="lead-company">{lead.company}</div>
              <div className="lead-email">{lead.email}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="lead-details">
        {selectedLead ? (
          <>
            <h2>Lead Details</h2>
            <div className="detail-content">
              <p><strong>ID:</strong> {selectedLead.id}</p>
              <p><strong>Company:</strong> {selectedLead.company}</p>
              <p><strong>Name:</strong> {`${selectedLead.firstName} ${selectedLead.lastName}`}</p>
              <p><strong>Email:</strong> {selectedLead.email}</p>
              <p><strong>Status:</strong> {selectedLead.status}</p>
            </div>
          </>
        ) : (
          <div className="no-selection">
            <p>Select a lead to view details</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default SalesforceLeads;
